/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ChangeClientUserPasswordRequest,
  HttpValidationProblemDetails,
  OwnPortalSessionDto,
  PortalProfileDto,
  RevokeOtherSessionsResult,
  UpdateClientUserProfileRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const portalProfileGetPortalMe = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalProfileDto>({ url: `/portal/me`, method: 'GET', signal }, options);
};

export const getPortalProfileGetPortalMeQueryKey = () => {
  return [`/portal/me`] as const;
};

export const getPortalProfileGetPortalMeQueryOptions = <
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMe>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalProfileGetPortalMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalProfileGetPortalMe>>> = ({
    signal,
  }) => portalProfileGetPortalMe(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalProfileGetPortalMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalProfileGetPortalMe>>
>;
export type PortalProfileGetPortalMeQueryError = unknown;

export function usePortalProfileGetPortalMe<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMe>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
          TError,
          Awaited<ReturnType<typeof portalProfileGetPortalMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalProfileGetPortalMe<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMe>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
          TError,
          Awaited<ReturnType<typeof portalProfileGetPortalMe>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalProfileGetPortalMe<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalProfileGetPortalMe<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMe>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMe>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalProfileGetPortalMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalProfilePutPortalMe = (
  updateClientUserProfileRequest: UpdateClientUserProfileRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<PortalProfileDto>(
    {
      url: `/portal/me`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateClientUserProfileRequest,
    },
    options,
  );
};

export const getPortalProfilePutPortalMeMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalProfilePutPortalMe>>,
    TError,
    { data: UpdateClientUserProfileRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalProfilePutPortalMe>>,
  TError,
  { data: UpdateClientUserProfileRequest },
  TContext
> => {
  const mutationKey = ['portalProfilePutPortalMe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalProfilePutPortalMe>>,
    { data: UpdateClientUserProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return portalProfilePutPortalMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalProfilePutPortalMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalProfilePutPortalMe>>
>;
export type PortalProfilePutPortalMeMutationBody = UpdateClientUserProfileRequest;
export type PortalProfilePutPortalMeMutationError = HttpValidationProblemDetails;

export const usePortalProfilePutPortalMe = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalProfilePutPortalMe>>,
      TError,
      { data: UpdateClientUserProfileRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalProfilePutPortalMe>>,
  TError,
  { data: UpdateClientUserProfileRequest },
  TContext
> => {
  const mutationOptions = getPortalProfilePutPortalMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalProfilePostPortalMeChangePassword = (
  changeClientUserPasswordRequest: ChangeClientUserPasswordRequest,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PortalProfileDto>(
    {
      url: `/portal/me/change-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changeClientUserPasswordRequest,
      signal,
    },
    options,
  );
};

export const getPortalProfilePostPortalMeChangePasswordMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalProfilePostPortalMeChangePassword>>,
    TError,
    { data: ChangeClientUserPasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalProfilePostPortalMeChangePassword>>,
  TError,
  { data: ChangeClientUserPasswordRequest },
  TContext
> => {
  const mutationKey = ['portalProfilePostPortalMeChangePassword'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalProfilePostPortalMeChangePassword>>,
    { data: ChangeClientUserPasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return portalProfilePostPortalMeChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalProfilePostPortalMeChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalProfilePostPortalMeChangePassword>>
>;
export type PortalProfilePostPortalMeChangePasswordMutationBody = ChangeClientUserPasswordRequest;
export type PortalProfilePostPortalMeChangePasswordMutationError = HttpValidationProblemDetails;

export const usePortalProfilePostPortalMeChangePassword = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalProfilePostPortalMeChangePassword>>,
      TError,
      { data: ChangeClientUserPasswordRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalProfilePostPortalMeChangePassword>>,
  TError,
  { data: ChangeClientUserPasswordRequest },
  TContext
> => {
  const mutationOptions = getPortalProfilePostPortalMeChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalProfileGetPortalMeSessions = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<OwnPortalSessionDto[]>(
    { url: `/portal/me/sessions`, method: 'GET', signal },
    options,
  );
};

export const getPortalProfileGetPortalMeSessionsQueryKey = () => {
  return [`/portal/me/sessions`] as const;
};

export const getPortalProfileGetPortalMeSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPortalProfileGetPortalMeSessionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>> = ({
    signal,
  }) => portalProfileGetPortalMeSessions(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PortalProfileGetPortalMeSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>
>;
export type PortalProfileGetPortalMeSessionsQueryError = unknown;

export function usePortalProfileGetPortalMeSessions<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
          TError,
          Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalProfileGetPortalMeSessions<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
          TError,
          Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePortalProfileGetPortalMeSessions<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function usePortalProfileGetPortalMeSessions<
  TData = Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portalProfileGetPortalMeSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortalProfileGetPortalMeSessionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const portalProfilePostPortalMeSessionsIdGuidRevoke = (
  id: string,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<void>(
    { url: `/portal/me/sessions/${id}/revoke`, method: 'POST', signal },
    options,
  );
};

export const getPortalProfilePostPortalMeSessionsIdGuidRevokeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsIdGuidRevoke>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsIdGuidRevoke>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['portalProfilePostPortalMeSessionsIdGuidRevoke'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsIdGuidRevoke>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return portalProfilePostPortalMeSessionsIdGuidRevoke(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalProfilePostPortalMeSessionsIdGuidRevokeMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsIdGuidRevoke>>
>;

export type PortalProfilePostPortalMeSessionsIdGuidRevokeMutationError = unknown;

export const usePortalProfilePostPortalMeSessionsIdGuidRevoke = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsIdGuidRevoke>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsIdGuidRevoke>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPortalProfilePostPortalMeSessionsIdGuidRevokeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const portalProfilePostPortalMeSessionsRevokeOthers = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<RevokeOtherSessionsResult>(
    { url: `/portal/me/sessions/revoke-others`, method: 'POST', signal },
    options,
  );
};

export const getPortalProfilePostPortalMeSessionsRevokeOthersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsRevokeOthers>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsRevokeOthers>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['portalProfilePostPortalMeSessionsRevokeOthers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsRevokeOthers>>,
    void
  > = () => {
    return portalProfilePostPortalMeSessionsRevokeOthers(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PortalProfilePostPortalMeSessionsRevokeOthersMutationResult = NonNullable<
  Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsRevokeOthers>>
>;

export type PortalProfilePostPortalMeSessionsRevokeOthersMutationError = unknown;

export const usePortalProfilePostPortalMeSessionsRevokeOthers = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsRevokeOthers>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof portalProfilePostPortalMeSessionsRevokeOthers>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPortalProfilePostPortalMeSessionsRevokeOthersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
